import type { SxProps, Theme, TypographyProps } from "@mui/material";
import { Link } from "@mui/material";
import TypographyTooltipEllipsis from "@entrilia/shared/components/TypographyTooltipEllipsis";
import useMergedSx from "@entrilia/shared/hooks/useMergedSx";
import useClientContext from "../../../../context/useClientContext";
import { getObjectPageRoute } from "../../../../utilities/navigationHelper";

export type RelatedRecordType = "Fund" | "Investor" | "Contact";

interface Props {
  recordType: RelatedRecordType;
  recordId: string;
  text: string;
  sx?: SxProps<Theme>;
  typographyProps?: TypographyProps;
}

const RelatedCommMatrixRecordLink = ({ recordType, recordId, text, sx, typographyProps }: Props) => {
  const { clientCode } = useClientContext();
  const linkSx = useMergedSx({ color: "text.primary", minWidth: 0, overflow: "hidden" }, sx);

  return (
    <Link
      className="highlighted-action"
      href={getObjectPageRoute(clientCode, recordId, recordType)}
      target="_blank"
      rel="noopener noreferrer"
      underline="none"
      sx={linkSx}
    >
      <TypographyTooltipEllipsis text={text} typographyProps={typographyProps} />
    </Link>
  );
};

export default RelatedCommMatrixRecordLink;
